// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleVerificationStatusAPIModel
 */
export interface SimpleVerificationStatusAPIModel {
    /**
     * 
     * @type {string}
     * @memberof SimpleVerificationStatusAPIModel
     */
    status: SimpleVerificationStatusAPIModelStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum SimpleVerificationStatusAPIModelStatusEnum {
    Verified = 'Verified',
    InProgress = 'InProgress',
    NotVerified = 'NotVerified',
    VerificationFailed = 'VerificationFailed'
}

export function SimpleVerificationStatusAPIModelFromJSON(json: any): SimpleVerificationStatusAPIModel {
    return SimpleVerificationStatusAPIModelFromJSONTyped(json, false);
}

export function SimpleVerificationStatusAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleVerificationStatusAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function SimpleVerificationStatusAPIModelToJSON(value?: SimpleVerificationStatusAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}


